import React, { useEffect } from "react";
import { newOnboardingSteps } from "../../locales/en";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import LoginAsUser from "../../components/loginasuser/LoginAsUser";
import Steps from "./steps";
import "./../../assets/scss/onboarding.scss";
import {
  INFO_EMAIL,
  MAILTO_INFO_EMAIL
} from "../../utils/constants/appConstants";
import { Link, Navigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import useProfile from "../../hooks/useProfile";
import { isOnboardingUserStatus } from "../../utils/onboardingVisibility";
import { INVOICE } from "../../route/paths";

const Onboarding = () => {
  // Account status decides who sees onboarding: Pending, Archived and
  // Customer DD, and nobody else. The banner and the redirects apply the same
  // rule, so this page is the last way a decided account could still reach the
  // accordion — by typing the URL, or by following a link saved before the
  // funding decision. See docs/decisions/0060.
  const { profile } = useProfile();
  const hasProfile = Boolean(profile?.id);
  const seesOnboarding = isOnboardingUserStatus(profile?.userStatusId);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  // The status is unknown until the profile lands, and guessing either way is
  // wrong: rendering flashes the accordion at a decided account, redirecting
  // throws a Pending one off the page it asked for.
  if (!hasProfile) {
    return (
      <>
        <HeaderDashboard />
        <LoginAsUser />
      </>
    );
  }

  if (!seesOnboarding) {
    return <Navigate to={INVOICE} replace />;
  }

  return (
    <>
      <HeaderDashboard />
      <LoginAsUser />
      <div className="onboarding-wrap mb-3 mt-2">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="onboarding-wrap-container">
                <Link to="/invoice" className="back-to-invoices">
                  <ChevronLeft size={16} aria-hidden="true" />
                  {newOnboardingSteps?.backToInvoices}
                </Link>
                <div className="onboard-title">
                  <h1>{newOnboardingSteps?.onBoardPageTitle}</h1>
                  <p>{newOnboardingSteps?.onBoardPageContent}</p>
                </div>
                <div className="onboarding-steps mt-4 pb-2">
                  <div className="label-title">
                    <h3>{newOnboardingSteps?.requiredTitle}</h3>
                  </div>

                  <Steps />
                </div>
                <div className="onboarding-footer mt-5 pt-3 pb-5">
                  <p>
                    {`${newOnboardingSteps?.footerText} `}
                    <Link to={MAILTO_INFO_EMAIL}>{INFO_EMAIL}</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Onboarding;
